import type { TranslationKey } from '../i18n.js';

type T = (key: TranslationKey, vars?: Record<string, string | number>) => string;

/**
 * La page de connexion.
 *
 * Pas de formulaire : l'identité est celle de Microsoft 365, et Mnemo ne voit jamais de
 * mot de passe. Un seul bouton, et le chemin d'où l'on vient est préservé — un lien
 * partagé vers `/?etab=EPAI` ramène là après la connexion, pas sur l'accueil.
 */
export function Login({ t, reason }: { t: T; reason: string | null }) {
  const login = () => {
    const returnTo = `${location.pathname}${location.search}`;
    location.href = `/api/auth/login?returnTo=${encodeURIComponent(returnTo)}`;
  };

  return (
    <main className="flex min-h-[70vh] items-center justify-center p-6">
      <div className="card w-full max-w-md p-8 text-center">
        <p className="text-2xl font-bold text-accent">{t('app.name')}</p>
        <p className="mt-1 text-sm text-muted">{t('app.tagline')}</p>

        {/* Une erreur de connexion se dit, elle ne se devine pas. */}
        {reason && (
          <p role="alert" className="mt-6 rounded-lg bg-warn/15 px-3 py-2 text-sm">
            <span aria-hidden="true">⚠ </span>
            {t(reason === 'expired' ? 'login.expired' : 'login.failed')}
          </p>
        )}

        <button type="button" className="btn-primary mt-8 w-full" onClick={login}>
          {t('login.action')}
        </button>

        <p className="mt-6 text-xs text-muted">{t('login.note')}</p>
      </div>
    </main>
  );
}
